module.exports = __webpack_public_path__ + "img/icon_3_40.a473edfa.png";